import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Button,
  DialogActions,
  Snackbar,
  Alert,
} from "@mui/material";
import { useAuth } from "../context/AuthContext";
import { login as loginAPI } from "../services/index";

const LoginModal = ({ open, onClose,onLoginSuccess }) => {
  const { login } = useAuth();
  const [form, setForm] = useState({ email: "", password: "" });

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleLogin = async () => {
    try {
      const response = await loginAPI({
        email: form.email,
        password: form.password,
      });

      if (response.status === 200) {
        const logindata= JSON.stringify(response.data);
        const { token, user_type ,data} = response.data;
        localStorage.setItem("token", token);
       

        login(user_type,logindata); 
        onClose(); // close modal
       
        const Id = logindata.id
        //  console.log("dataaaaaaaaaaaaa",Id);
        setSnackbar({
          open: true,
          message: "Login successful!",
          severity: "success",
        });
        if (onLoginSuccess) {
        onLoginSuccess(true, Id); // Pass the user ID
      }
      }
    } catch (error) {
      console.error("Login error:", error?.response?.data?.message);
      setSnackbar({
        open: true,
        message: error?.response?.data?.message || "Login failed. Please try again.",
        severity: "error",
      });
      if (onLoginSuccess) {
        onLoginSuccess(false);
      }
    }
  };

  return (
    <>
      <Dialog open={open} onClose={onClose}>
        <DialogTitle>Login</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            name="email"
            label="Email Address"
            fullWidth
            variant="standard"
            onChange={handleChange}
          />
          <TextField
            margin="dense"
            name="password"
            label="Password"
            type="password"
            fullWidth
            variant="standard"
            onChange={handleChange}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button onClick={handleLogin}>Login</Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: "100%" }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default LoginModal;
